<p-dialog [header]="isEditMode ? ('smsEventDailog.editSmsEvent' | transloco) : ('smsEventDailog.addSmsEvent' | transloco)" [(visible)]="isAddEmailEventDailogVisible"
  [modal]="true" [style]="{'width': '600px'}" (onHide)="onCloseEmailEventsDialog()">


  <!-- Form Content -->
  @if (emailEventsFormData) {
    <form>
      <div class="card border-0 shadow-sm">
        <div class="card-body p-3">
          <!-- Name Field -->
          <div class="mb-2">
            <label for="name" class="form-label fw-bold">
              <i class="fa fa-heading me-2 text-dark"></i>
              <span class="text-danger">*</span> {{ 'smsEventDailog.name' | transloco }}
            </label>
            <input type="text" class="form-control form-control-lg" [placeholder]="'smsEventDailog.enterEventName' | transloco"
              [(ngModel)]="emailEventsFormData.Name" name="name" id="name" required
              [pTooltip]="'smsEventDailog.nameTooltip' | transloco" tooltipPosition="top" />
              <div class="form-text text-muted small">
                <i class="fa fa-lightbulb me-1"></i>
                {{ 'smsEventDailog.nameHint' | transloco }}
              </div>
            </div>
            <!-- Description Field -->
            <div class="mb-2">
              <label for="description" class="form-label fw-bold">
                <i class="fa fa-info-circle me-2 text-info"></i>{{ 'smsEventDailog.description' | transloco }}
              </label>
              <textarea id="description" class="form-control form-control-lg"
                [(ngModel)]="emailEventsFormData.Description" [placeholder]="'smsEventDailog.enterEventDescription' | transloco"
                name="description" style="height: 190px;"
              [pTooltip]="'smsEventDailog.descriptionTooltip' | transloco" tooltipPosition="top"></textarea>
              <div class="form-text text-muted small">
                <i class="fa fa-lightbulb me-1"></i>
                {{ 'smsEventDailog.descriptionHint' | transloco }}
              </div>
            </div>
            <!-- Parameters Field -->
            <div class="mb-2">
              <label for="emailParameterIds" class="form-label fw-bold">
                <i class="fa fa-code me-2 text-success"></i>{{ 'smsEventDailog.parameters' | transloco }}
              </label>
              <p-multiSelect [options]="emailParameters" name="emailParameterIds" [placeholder]="'smsEventDailog.selectParameters' | transloco"
                optionLabel="label" appendTo="body" [(ngModel)]="selectedEmailParameters"
                (onChange)="onEventParametersChange($event)" [style]="{'width': '100%'}" [maxSelectedLabels]="6"
                class="p-inputtext-lg" [pTooltip]="'smsEventDailog.parametersTooltip' | transloco"
                tooltipPosition="top">
              </p-multiSelect>
              <div class="form-text text-muted small">
                <i class="fa fa-lightbulb me-1"></i>
                {{ 'smsEventDailog.parametersHint' | transloco }}
              </div>
            </div>
            <!-- Save Button -->
            <div class="d-flex gap-2 justify-content-end">
              <button pButton type="button" icon="pi pi-save" [label]="'smsEventDailog.save' | transloco"
                class="p-button-outlined p-button-primary p-button-rounded" (click)="onSaveEmailEvents()"
                [disabled]="!emailEventsFormData.Name" [pTooltip]="'smsEventDailog.saveTooltip' | transloco" tooltipPosition="top">
              </button>
            </div>
          </div>
        </div>
      </form>
    }
  </p-dialog>